'use es6';

import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import GoodTile from 'marketplace-lib/components/goods/GoodTile';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import { isCustomModule, isTemplatePack, isTheme } from '../utils/utils';
import GoodTileLink from './GoodTileLink';

var GoodsGrid = function GoodsGrid(_ref) {
  var goods = _ref.goods,
      trackLinkClick = _ref.trackLinkClick;
  return React.createElement(UIGrid, {
    className: "directory-grid-margin-adjustment"
  }, goods.map(function (good) {
    var goodUrlToken = good.get('urlToken');

    var LinkRenderer = function LinkRenderer(props) {
      return React.createElement(GoodTileLink, Object.assign({}, props, {
        goodUrlToken: goodUrlToken
      }));
    };

    var tileProps = {
      cardProps: {
        'data-test-id': 'good-tile'
      },
      goodImageUrl: good.get('marketingImageSmallUrl'),
      goodName: good.get('name'),
      goodPrice: good.get('price'),
      goodSubType: good.get('subType'),
      goodType: good.get('type'),
      goodUrlToken: goodUrlToken,
      isFree: good.get('free'),
      linkRenderer: LinkRenderer,
      onClick: function onClick() {
        return trackLinkClick('good-tile');
      },
      reviewInfo: good.get('reviewInfo')
    };

    if (isCustomModule(good)) {
      tileProps = Object.assign({}, tileProps, {
        moduleCompatibility: good.get('moduleCompatibilities').toArray(),
        moduleSummary: good.get('marketingSummary')
      });
    } else if (isTemplatePack(good)) {
      tileProps = Object.assign({}, tileProps, {
        packCounts: good.get('packCounts')
      });
    } else if (isTheme(good)) {
      tileProps = Object.assign({}, tileProps, {
        themeAssetNamesBySubType: good.get('assetNamesBySubType')
      });
    }

    return React.createElement(UIGridItem, {
      className: "directory-grid-tile-container",
      size: {
        md: 6,
        lg: 4,
        xl: 3
      },
      key: good.get('goodId') + good.get('name')
    }, React.createElement(GoodTile, tileProps));
  }));
};

GoodsGrid.propTypes = {
  goods: PropTypes.instanceOf(Immutable.List).isRequired,
  trackLinkClick: PropTypes.func.isRequired
};
export default GoodsGrid;